import FilledButton from "@/components/button/filled-button";
import { APP_ROUTES } from "@/constants/app-routes";
import { useGetUser } from "@/hooks/requests/user/use-get-user";
import { cn } from "@/utils/cn";
import { useIonRouter } from "@ionic/react";

export const NoPlanCard = () => {
  const navigation = useIonRouter();
  const { user } = useGetUser();
  const isOnboardingCompleted = user?.isOnboardingCompleted === true;
  return (
    <div
      className={cn(
        "h-80 rounded-2xl bg-white",
        "flex flex-col items-center justify-center gap-8 px-8 text-center",
      )}
    >
      <span className="text-lg font-semibold">No plan yet</span>
      <span className="text-sm text-gray-500">
        To create your personalised plan, you can setup your food profile. It only takes a minute.
      </span>

      <div className="flex w-full max-w-xs flex-col gap-3">
        {!isOnboardingCompleted && (
          <FilledButton
            text="Finish the Onboarding"
            color="dark"
            expand="full"
            onClick={() => {
              navigation.push(APP_ROUTES.ONBOARDING_START, "none");
            }}
            className="border-medium-default border"
          />
        )}
        <FilledButton
          text="Complete My Favourites"
          color="dark"
          expand="full"
          onClick={() => {
            navigation.push("/profiling/go-to", "none");
          }}
          className="border-medium-default border"
        />
      </div>
    </div>
  );
};
